import type { InternalAxiosRequestConfig } from 'axios';

/** Exact opt-in policy for an isolated synthetic development UI. */
export const canBypassLocalDevAuth = (
    env: { DEV?: boolean; VITE_DEV_AUTH_BYPASS?: string },
    hostname: string | undefined,
): boolean =>
    env.DEV === true &&
    env.VITE_DEV_AUTH_BYPASS === 'true' &&
    (hostname === 'localhost' || hostname === '127.0.0.1');

/** Keep the synthetic dev request separate from real browser credentials. */
export const stripLocalDevCredentials = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    config.headers.delete('Authorization');
    config.withCredentials = false;
    delete config.auth;
    return config;
};
